export default "__VITE_ASSET__CEBSfLCx__"